import React from "react";

import FaturamentoTabela from "../FaturamentoTabela";

import "./styles.css";

export default function Lotes() {
  return <FaturamentoTabela visualizacao="lotes" />;
}
